/**
 * Resolves branding key (translations, logos, external links) from the current host.
 * Mirrors deployment sections in `.env.production` (main / noor / rch, etc.).
 */
const HOSTNAME_ORIGIN_MAP: Record<string, string> = {
  // main (VITE_ORIGIN_NAME=bioarc)
  "biomeet.ir": "bioarc",
  "www.biomeet.ir": "bioarc",
  // noor (VITE_ORIGIN_NAME=faranor)
  "onlinevisit.noorvision.com": "faranor",
  "www.onlinevisit.noorvision.com": "faranor",
  // rhc (VITE_ORIGIN_NAME=rhc)
  "rhc.biomeet.ir": "rhc",
  "www.rhc.biomeet.ir": "rhc",
  // iums (VITE_ORIGIN_NAME=iums)
  "iums.biomeet.ir": "iums",
  "www.iums.biomeet.ir": "iums",
  // behdashttums (VITE_ORIGIN_NAME=behdashttums)
  "behdasht.biomeet.ir": "behdashttums",
  "www.behdasht.biomeet.ir": "behdashttums",
  // tums (VITE_ORIGIN_NAME=tums)
  "tums.biomeet.ir": "tums",
  "www.tums.biomeet.ir": "tums",
  // isaimed (VITE_ORIGIN_NAME=isaimed)
  "isaimed.biomeet.ir": "isaimed",
  "www.isaimed.biomeet.ir": "isaimed",
  // abzums (VITE_ORIGIN_NAME=abzums)
  "abzums.biomeet.ir": "abzums",
  "www.abzums.biomeet.ir": "abzums",
  // thcb (VITE_ORIGIN_NAME=thcb)
  "thc.biomeet.ir": "thcb",
  "www.thc.biomeet.ir": "thcb",
};

function resolveOriginName(): string {
  // return "bioarc";
  if (typeof window === "undefined") {
    return import.meta.env.VITE_ORIGIN_NAME || "bioarc";
  }

  const host = window.location.hostname.toLowerCase();
  const mapped = HOSTNAME_ORIGIN_MAP[host];
  if (mapped) return mapped;

  if (host.endsWith(".rhc.ac.ir")) return "rhc";
  if (host.endsWith(".noorvision.com")) return "faranor";
  if (host.endsWith(".biomeet.ir")) return "bioarc";
  if (host.endsWith(".iums.ac.ir")) return "iums";
  if (host.endsWith(".tums.ac.ir")) return "tums";
  if (host.endsWith(".behdashttums.ac.ir")) return "behdashttums";

  return import.meta.env.VITE_ORIGIN_NAME || "bioarc";
}

/** Current tenant key; stable for the SPA session after first evaluation. */
export const originName = resolveOriginName();
